// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/home/runner/work/GPT-Vis/GPT-Vis/node_modules/.pnpm/dumi@2.4.21_@babel+core@7.28.0_@swc+helpers@0.5.1_@types+node@24.0.14_@types+react@18.3.23_@t_n3pfsrvzcbo6za7u5d6thsteeq/node_modules/dumi/theme-default/slots/Toc/index.js';
